import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import Api from '../api/Api';
import { QUERY_KEYS } from "./queryKeys";
import { useMapLayerStore } from "../store/layerStore";
import useDatasetStore from "../store/datasetStore";

export const useInitStaticLayers = () => {
  const setGlobalShapeFile = useMapLayerStore(state => state.setGlobalShapeFile);
  const setDatasetZones = useMapLayerStore(state => state.setDatasetZones);
  const setFWEModelDomains = useMapLayerStore(state => state.setFWEModelDomains);

  const getAllDatasetIds = useDatasetStore(state => state.getAllDatasetIds);
  const getFWEDatasetIds = useDatasetStore(state => state.getFWEDatasetIds);
  const isApiInitialized = Boolean(Api?.configData);

  const globalLayerQuery = useQuery({
    queryKey: [QUERY_KEYS.map.globalLayer],
    queryFn: () => Api.fileEndPoint.getOverlayGeoJson(
      'Merged_OWF_Many',
      'Offshore Wind Farms',
      'Offshore Wind Farms',
      '#B5651D'
    ),
    enabled: isApiInitialized,
    retry: 3
  });

  const moodSpaceQuery = useQuery({
    queryKey: [QUERY_KEYS.map.moodSpace, getAllDatasetIds()],
    queryFn: async () => {
      const datasetIds = getAllDatasetIds();
      if (datasetIds.length === 0) return [];
      return Api.downloadRequest.getAllMoodSpaceDefinition(datasetIds);
    },
    enabled: getAllDatasetIds().length > 0
  });

  const fweModelDomainQuery = useQuery({
    queryKey: [QUERY_KEYS.map.fweModelDomain, getAllDatasetIds()],
    queryFn: async () => {
      const datasetIds = getFWEDatasetIds();
      if (datasetIds.length === 0) return [];
      return Api.downloadRequest.getAllFWESpaceDefinition(datasetIds);
    },
    enabled: getFWEDatasetIds().length > 0
  });

  useEffect(() => {
    if (globalLayerQuery.data) {
      setGlobalShapeFile(globalLayerQuery.data);
    }
  }, [globalLayerQuery.data, setGlobalShapeFile]);

  useEffect(() => {
    if (moodSpaceQuery.data) {
      setDatasetZones(moodSpaceQuery.data);
    }
  }, [moodSpaceQuery.data, setDatasetZones]);

  useEffect(() => {
    if (fweModelDomainQuery.data && fweModelDomainQuery.data.length > 0) {
      setFWEModelDomains(fweModelDomainQuery.data);
    }
  }, [fweModelDomainQuery.data, setFWEModelDomains]);
};
